<div ngModelGroup="scan">
    <div class="form-group row" *ngIf="hasCrawlAutomatically">
        <label class="col-sm-8 col-form-label text-bold text-right" for="domain_active">
            {{ 'Crawl Automatically' | translate }}
        </label>
        <div class="col-sm-40">
            <mon-switch
                name="domain_active"
                [(ngModel)]="domain.active">
            </mon-switch>
        </div>
    </div>

    <div *ngIf="domain.active">
        <form-field-select
            *ngIf="hasCustomScanTrait"
            name="scanFrequency"
            [(ngModel)]="scanIntervalValue"
            [label]="'Scan frequency' | translate"
            [defaultOption]="'Frequency' | translate"
            [options]="scanIntervalOptions"
            returnValue="value"
            (ngModelChange)="setScanInterval()"
            type="number">
        </form-field-select>

        <div class="form-group row mt-2" *ngIf="!hasCustomScanTrait">
            <label class="col-form-label text-right text-bold col-sm-8"
                for="scan_interval_input">
                {{ 'Scan frequency' | translate }}
            </label>
            <div class="col-sm-40 d-flex align-items-center">
                <span>{{ scanIntervalName }}
                    <span *ngIf="scanIntervalValue !== -1"
                        class="outer-l-smurf fas fa-question-circle"
                        aria-hidden="true"
                        [title]="('Your next scan is scheduled for: ' | translate) + nextScanDate">
                    </span>
                    <span *ngIf="scanIntervalValue !== -1"
                          class="outer-l-smurf fas fa-question-circle"
                          aria-hidden="true"
                          [ngbTooltip]="('Your next scan is scheduled for: ' | translate) + nextScanDate"
                          placement="top-right"
                          tooltipClass="no-limit"
                          container="body"
                          [triggers]="'focus hover'"></span>
                </span>
            </div>
        </div>

        <form-field-select
            [(ngModel)]="domain.scan.day"
            name="scanDay"
            [label]="'Day' | translate"
            [defaultOption]="'Day' | translate"
            [options]="dayOptions"
            (ngModelChange)="updateNextScanDate()"
            returnValue="value"
            type="text">
        </form-field-select>

        <div class="form-group row mt-2">
            <label id="domain-scan-label" class="col-form-label text-bold text-right col-sm-8">
                {{ 'Time' | translate }}
            </label>

            <div class="pl-3">
                <ngb-timepicker [(ngModel)]="domain.scan.time"
                                name="domainScanTime"
                                (ngModelChange)="updateNextScanDate()"
                                id="domain-scan"
                                aria-labelledby="domain-scan-label"
                                [meridian]="true"
                                [spinners]="false"
                ></ngb-timepicker>
            </div>
        </div>
    </div>

    <form-field-select
        [(ngModel)]="domain.scan.connections_per_minute"
        name="scanConnectionsPerMinute"
        [label]="'Connections per minute' | translate"
        [defaultOption]="'Connections per minute' | translate"
        returnValue="value"
        [options]="connectionOptions"
        type="number">
    </form-field-select>

    <hr class="row outer-b-none outer-t-large" />

    <div *ngIf="customer">
        <mon-panel-header
            [hideHr]="'true'"
            eClass="mt-6"
            transcludeClass="flex-fill"
            [pHeader]="'Max' | translate">
        </mon-panel-header>

        <div class="form-group row">
            <label class="col-form-label text-right text-bold col-sm-8" for="domain_scan_max_scanned_pages">
                {{ 'Max scanned pages' | translate }}
            </label>
            <div class="col-sm-40">
                <input type="number"
                    id="domain_scan_max_scanned_pages"
                    class="form-control"
                    [placeholder]="'Max scanned pages' | translate"
                    min="0"
                    [max]="customer.plan_traits.max_scanned_pages || 0"
                    name="domain_scan_max_scanned_pages"
                    #domainScanMaxScannedPages="ngModel"
                    [(ngModel)]="domain.scan.max_scanned_pages" />
            </div>
        </div>
        <form-field-errors [input]="domainScanMaxScannedPages.control"></form-field-errors>
    </div>

    <hr class="row outer-b-none mt-6" />
    <mon-panel-header
        [hideHr]="'true'"
        eClass="mt-6"
        transcludeClass="flex-fill"
        [pHeader]="'Crawl Options' | translate">
    </mon-panel-header>

    <div class="form-group row">
        <label class="col-sm-8 col-form-label text-bold text-right" for="scan_subdomains">
            {{ 'Scan subdomains' | translate }}
        </label>
        <div class="col-sm-40">
            <mon-switch name="scan_subdomains"
                [(ngModel)]="domain.scan.scan_subdomains">
            </mon-switch>
        </div>
    </div>

    <div class="form-group row">
        <label class="col-sm-8 col-form-label text-bold text-right" for="spelling_ignore_capitalized_words">
            {{ 'Spelling ignore capitalized words' | translate }}
        </label>
        <div class="col-sm-40">
            <mon-switch name="spelling_ignore_capitalized_words"
                [(ngModel)]="domain.scan.spelling_ignore_capitalized_words">
            </mon-switch>
        </div>
    </div>

    <div class="form-group row">
        <label class="col-sm-8 col-form-label text-bold text-right" for="case_sensitive">
            {{ 'Case sensitive URLs' | translate }}
        </label>
        <div class="col-sm-40">
            <mon-switch name="case_sensitive"
                [(ngModel)]="domain.scan.case_sensitive">
            </mon-switch>
        </div>
    </div>

    <div class="form-group row">
        <label class="col-sm-8 col-form-label text-bold text-right" for="enable_javascript">
            {{ 'Render pages and execute JS while crawling' | translate }}
        </label>
        <div class="col-sm-40">
            <mon-switch name="enable_javascript"
                [(ngModel)]="domain.scan.enable_javascript">
            </mon-switch>
        </div>
    </div>

    <div class="form-group row">
        <label class="col-sm-8 col-form-label text-bold text-right" for="auth_required_as_error">
            {{ 'Mark 403 as broken link' | translate }}
        </label>
        <div class="col-sm-40">
            <mon-switch name="auth_required_as_error"
                [(ngModel)]="domain.scan.auth_required_as_error">
            </mon-switch>
        </div>
    </div>

    <div class="form-group row">
        <label class="col-sm-8 col-form-label text-bold text-right" for="ignore_canonical">
            {{ 'Ignore canonical URLs' | translate }}
        </label>
        <div class="col-sm-40">
            <mon-switch name="ignore_canonical"
                [(ngModel)]="domain.scan.ignore_canonical">
            </mon-switch>
        </div>
    </div>

    <div class="form-group row">
        <label class="col-sm-8 col-form-label text-bold text-right" for="use_language_attribute">
            {{ 'Use language attribute' | translate }}
        </label>
        <div class="col-sm-40">
            <mon-switch name="use_language_attribute"
                [(ngModel)]="domain.scan.use_lang_attribute">
            </mon-switch>
        </div>
    </div>

    <hr class="row outer-b-none mt-6" />
    <mon-panel-header-next
        [hideHr]="true"
        eClass="outer-t-large"
        [pHeader]="'Advanced Domain Options' | translate">
    </mon-panel-header-next>

    <div class="row">
        <div class="offset-sm-8 col-sm-40">
            <h3 class="font-weight-300">{{ 'Path constraints' | translate }}</h3>
        </div>
    </div>
    <mon-spinner [loading]="isContstraintsLoading">
        <form-field-dynamic
                class="field-with-label"
                (monLabelDeleteButtonClick)="onDeleteConstraintsDefaultLabelClick($event)"
                attrName="constraint"
                [model]="domain.path_constraints"
                name="domainPathConstraints"
                (inputValueChanged)="onInputValueChanged($event, 'pathConstraints')"
                [monDynamicComponentRightItemLabels]="constraintsRightItemLabels"
                [monRightItemLabelsTooltip]="labelTooltipText"
                [allowSearch]="true"
                [pageSize]="5"
                [allowPagination]="true"
                [label]="'Constraint pattern' | translate"
                [placeholder]="'Constraint pattern' | translate"
                type="text"
                [confirmMsg]="'Remove this pattern?' | translate">
        </form-field-dynamic>
    </mon-spinner>

    <div class="row">
        <div class="offset-sm-8 col-sm-40">
            <h3 class="font-weight-300">{{ 'Link excludes' | translate }}</h3>
        </div>
    </div>
    <mon-spinner [loading]="isLinkExcludesLoading">
        <form-field-dynamic
                class="field-with-label"
                (monLabelDeleteButtonClick)="onDeleteLinksDefaultLabelClick($event)"
                attrName="regex"
                [model]="domain.link_excludes"
                name="domainLinkExcludes"
                (inputValueChanged)="onInputValueChanged($event, 'linkExcludes')"
                [monDynamicComponentRightItemLabels]="linkExcludesRightItemLabels"
                [monRightItemLabelsTooltip]="labelTooltipText"
                [allowSearch]="true"
                [pageSize]="5"
                [allowPagination]="true"
                [label]="'Exclude pattern' | translate"
                [placeholder]="'Exclude pattern' | translate"
                type="text"
                [confirmMsg]="'Remove this pattern?' | translate">
        </form-field-dynamic>
    </mon-spinner>

    <div class="row">
        <div class="offset-sm-8 col-sm-40">
            <h3 class="font-weight-300">{{ 'Internal URLs' | translate }}</h3>
        </div>
    </div>
    <form-domain-scan-internal-urls
        [(internalUrls)]="domain.additional_internal_urls">
    </form-domain-scan-internal-urls>

    <hr class="row outer-b-none" />
    <mon-panel-header
        [hideHr]="'true'"
        eClass="mt-6"
        [pHeader]="'Login Type' | translate">
    </mon-panel-header>

    <div class="form-group row">
        <label for="scan_login"
            class="col-sm-8 col-form-label text-bold text-right">
            {{ 'Select login type*' | translate }}
        </label>
        <div class="col-sm-40">
            <angular-selector
                id="scan_login"
                [removeButton]="false"
                labelAttr="name"
                valueAttr="value"
                [placeholder]="'Choose notification time' | translate"
                [options]="loginTypes"
                [(ngModel)]="domain.scan.login.type"
                name="scanLoginType"
                [required]="true">
            </angular-selector>
        </div>
    </div>

    <form-domain-scan-login-types-form
        *ngIf="domain.scan.login.type === 'form'"
        [login]="domain.scan.login">
    </form-domain-scan-login-types-form>

    <form-domain-scan-login-types-office365
        *ngIf="domain.scan.login.type === 'office365'"
        [(login)]="domain.scan.login">
    </form-domain-scan-login-types-office365>

    <form-domain-scan-login-types-basic-auth
        (whenHostValidityChange)="onBasicAuthHostValidityChange($event.valid)"
        *ngIf="domain.scan.login.type === 'basic_auth'"
        [url]="domain.url"
        [login]="domain.scan.login">
    </form-domain-scan-login-types-basic-auth>

    <form-domain-scan-login-types-custom-multistep
        *ngIf="domain.scan.login.type === 'custom_multistep'"
        [login]="domain.scan.login">
    </form-domain-scan-login-types-custom-multistep>
</div>
